import React from "react";

export const Backend = () => (
    <span>Backend inspired by <a href={"https://github.com/ThatcherC/Terrain2STL"}>Thatcher Chamberlin</a></span>
);

export const MapData = () => (
    <span>Map data from <a href={"http://viewfinderpanoramas.org/"}>Viewfinder Panoramas</a></span>
);

export const Imprint = () => (
    <a href={"https://www.vivid-planet.com/impressum"}>Imprint</a>
);



// WEBPACK FOOTER //
// ./src/common/Legal/Legal.js